module.exports = __webpack_public_path__ + "static/media/omnicode.7f72292f.png";